import { DEFAULT_REGION_CODE, REGIONS_DATA } from '@/data'

export const fields = `
  title,
  ${Object.values(REGIONS_DATA)
    .map(({ code: regionCode }) => {
      if (regionCode === DEFAULT_REGION_CODE) return ''
      return `
        $language == "${regionCode}" => {
          defined(${regionCode}Title) => {"title": ${regionCode}Title}
        },
      `
    })
    .join('')}
  slug
`

export const fragment = (name: string) => `${name}{
	${fields}
}`

const exports = { fields, fragment }

export default exports
